import { defineComponent as e } from "vue";
import "./CouponFeatured.css";
const t = e({
  name: "CouponFeatured",
  props: {
    couponShowCaseList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    CopyCoupon(o) {
      window.CopyCouponCode(o);
    }
  }
});
export {
  t as default
};
